import { z } from 'zod';
/** `media_assets.kind`. */
export const MEDIA_KINDS = ['IMAGE', 'VIDEO'];
export const MediaKindSchema = z.enum(MEDIA_KINDS);
/** `media_assets.purpose`. */
export const MEDIA_PURPOSES = [
    'CONTENT',
    'TEAM_LOGO',
    'PLAYER_PHOTO',
    'AD_CREATIVE',
    'AVATAR',
    'VENUE',
    'COMPETITION_LOGO',
];
export const MediaPurposeSchema = z.enum(MEDIA_PURPOSES);
/** `media_assets.status`; content is publishable only when READY (ADR-0011). */
export const MEDIA_STATUSES = ['UPLOADING', 'PROCESSING', 'READY', 'FAILED'];
export const MediaStatusSchema = z.enum(MEDIA_STATUSES);
/** `media_assets.uploadedBy.type`. */
export const UPLOADER_TYPES = ['ADMIN', 'APP_USER'];
export const UploaderTypeSchema = z.enum(UPLOADER_TYPES);
//# sourceMappingURL=media.js.map